// extracted by mini-css-extract-plugin
export default {"main":"AlertComponent_main__wBiRY","textNotif":"AlertComponent_textNotif__tGsNO","close":"AlertComponent_close__l1aM0"};